import React from 'react';
import { ProductMasterDataExportConfiguration } from '../types/product_master_data_export_configuration';

export interface ProductMasterDataExportConfigurationContextProps {
  productMasterDataExportConfigurations: Map<string, ProductMasterDataExportConfiguration>;
  setProductMasterDataExportConfigurations: (
    productMasterDataExportConfigurations: Map<string, ProductMasterDataExportConfiguration>,
  ) => void;
  productMasterDataExportConfigurationsLoading: boolean;
}

const defaultContext: ProductMasterDataExportConfigurationContextProps = {
  productMasterDataExportConfigurations: new Map(),
  setProductMasterDataExportConfigurations: () => {},
  productMasterDataExportConfigurationsLoading: false,
};

export const ProductMasterDataExportConfigurationContext =
  React.createContext<ProductMasterDataExportConfigurationContextProps>(defaultContext);
